import SeoHead from '../../components/SeoHead';
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import SimplePage from '../../components/SimplePage';
import Header from '../../components/MainHeader';
import TabTestimonial from '../../components/TabTestimonial';

export default function LetsGetStarted({
    global,
    all_temporary_testimonials,
    all_permanent_testimonials
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Let's get started | Gap Personnel`}
                // description={``}
                canonical_link={`/lets-get-started/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`lets_get_started_page.sub_banner`}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`Let's get started`}
                bannerImageAlt={`Let's get started Banner Image`}
                bannerImageAlt2={`Let's get started Banner Image 2`}
                bannerImage={`/site-assets/images/lets-get-started-img-1.jpg`}
                bannerImage2={`/site-assets/images/lets-get-started-img-2.jpg`}
                dualBannerImage={true}
            />
            <TabTestimonial
                global={global}
                pathPrefix={`lets_get_started_page.tab_testimonial`}
                customClass={`mt-5 pt-5`}
                heading={
                    <>
                        <h5>
                            Partnering with us is easy! Here's what to expect on your journey with us.
                        </h5>
                    </>
                }
                content={
                    <>
                        <h6><strong>Get in touch</strong></h6>
                        <p>Our teams are ready to help, no matter how big or small your requirements.
                            We can offer high volume temporary workforce supply with an onsite provision, a local branch-based team, or a combination of the two if you have multiple operations, or resourcing for permanent workers – just let us know what you need. Drop us your vacancy needs and we’ll give you a call back, or head over to our contact page and get in touch with your local team today.</p>
                    </>
                }
                column1Text={`Sourcing temporary or temp-to-perm staff?`}
                column2Text={`or`}
                column3Text={`Looking for a permanent addition to the team?`}
                testimonial1={all_temporary_testimonials}
                testimonial2={all_permanent_testimonials}
                postOrder={true}
            />
            <SimplePage
                global={global}
                pathPrefix={`lets_get_started_page.simple_page`}
                customClass={``}
                content={``}
                formId={`2b1903d0-c09a-4b34-9c3b-27a7b7afb573`}
                heading={`Get in touch`}
                textCenter={true}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const temporaryTag = "Temp to perm";
    const permanentTag = "Employers Permanent";

    const temporary_testimonials = (await Collection('testimonials'))
        .filter(function (post) {
            return (
                post.tag?.en.includes(temporaryTag)
            );
        })

    const permanent_testimonials = (await Collection('testimonials'))
        .filter(function (post) {
            return (
                post.tag?.en.includes(permanentTag)
            );
        })
    const all_temporary_testimonials = temporary_testimonials.orderBy('order').getItems();
    const all_permanent_testimonials = permanent_testimonials.orderBy('order').getItems();


    return {
        props: {
            global,
            all_temporary_testimonials,
            all_permanent_testimonials
        },
    }
}